/**
 * A helper to round a number / metric to two decimal places
 */
export const formatNumber = (value: number | string): string => parseFloat(`${value}`).toFixed(2);
